import gsap from "gsap";

export const searchOverlayOnEnter = () => {
    const tl = new gsap.timeline({});

    //enter animation
    tl.fromTo(
        "#search-overlay",
        { autoAlpha: 0, duration: 0 },
        {
            autoAlpha: 1,
            duration: 0.25,
        },
    );

    return tl;
};
export const searchOverlayOnExit = () => {
    const tl = new gsap.timeline({});
    //exit animation
    tl.fromTo(
        "#search-overlay",
        { autoAlpha: 1, duration: 0 },
        {
            autoAlpha: 0,
            duration: 0.25,
        },
    );

    return tl;
};
